"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEngagementSection = exports.TIER_DISTRIBUTION_ENABLED = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var lineChartCard_1 = require("../../charts/lineChartCard");
var compositeChartCard_1 = require("../../charts/compositeChartCard");
var stackedAreaChartCard_1 = require("../../charts/stackedAreaChartCard");
var activityHeatmapCard_1 = require("../../charts/activityHeatmapCard");
var chartColors_1 = require("../../charts/chartColors");
var kpiCard_1 = require("../../charts/kpiCard");
var formatChartData_1 = require("../../../helpers/analytics/formatChartData");
var compareTimePeriods_1 = require("../../../helpers/analytics/compareTimePeriods");
var dashboardGrid_1 = require("../dashboardGrid");
// Disabled until tier distribution reads current tier statistics instead of tier-change events.
var TIER_DISTRIBUTION_ENABLED = false;
exports.TIER_DISTRIBUTION_ENABLED = TIER_DISTRIBUTION_ENABLED;
var UserEngagementSection = (0, react_1.memo)(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var data = _a.data, loading = _a.loading, tier_distribution = _a.tier_distribution, tier_distribution_loading = _a.tier_distribution_loading, activity_heatmap = _a.activity_heatmap, activity_heatmap_loading = _a.activity_heatmap_loading;
    var mergedTimeSeries = (function () {
        var _a, _b, _c, _d;
        if (!(data === null || data === void 0 ? void 0 : data.dau_time_series) && !(data === null || data === void 0 ? void 0 : data.mau_time_series))
            return [];
        var dauByDate = {};
        var mauByDate = {};
        var prevDauByIndex = [];
        var prevMauByIndex = [];
        (_a = data === null || data === void 0 ? void 0 : data.dau_time_series) === null || _a === void 0 ? void 0 : _a.forEach(function (point) {
            dauByDate[point.date] = point.value;
        });
        (_b = data === null || data === void 0 ? void 0 : data.mau_time_series) === null || _b === void 0 ? void 0 : _b.forEach(function (point) {
            mauByDate[point.date] = point.value;
        });
        (_c = data === null || data === void 0 ? void 0 : data.prev_dau_time_series) === null || _c === void 0 ? void 0 : _c.forEach(function (point) { return prevDauByIndex.push(point.value); });
        (_d = data === null || data === void 0 ? void 0 : data.prev_mau_time_series) === null || _d === void 0 ? void 0 : _d.forEach(function (point) { return prevMauByIndex.push(point.value); });
        var allDates = Array.from(new Set(Object.keys(dauByDate).concat(Object.keys(mauByDate)))).sort();
        return allDates.map(function (date, index) {
            var _a, _b, _c, _d;
            return ({
                date: (0, formatChartData_1.formatBucketLabel)(date),
                dau: (_a = dauByDate[date]) !== null && _a !== void 0 ? _a : 0,
                mau: (_b = mauByDate[date]) !== null && _b !== void 0 ? _b : 0,
                prev_dau: (_c = prevDauByIndex[index]) !== null && _c !== void 0 ? _c : null,
                prev_mau: (_d = prevMauByIndex[index]) !== null && _d !== void 0 ? _d : null,
            });
        });
    })();
    var hasPrev = !!(((_b = data === null || data === void 0 ? void 0 : data.prev_dau_time_series) === null || _b === void 0 ? void 0 : _b.length) || ((_c = data === null || data === void 0 ? void 0 : data.prev_mau_time_series) === null || _c === void 0 ? void 0 : _c.length));
    var dauBreakdownData = (_e = (_d = data === null || data === void 0 ? void 0 : data.dau_breakdown) === null || _d === void 0 ? void 0 : _d.map(function (point) { return ({
        date: (0, formatChartData_1.formatBucketLabel)(point.date),
        new: point.new,
        returning: point.returning,
    }); })) !== null && _e !== void 0 ? _e : [];
    var tierDistributionData = (_g = (_f = tier_distribution === null || tier_distribution === void 0 ? void 0 : tier_distribution.buckets) === null || _f === void 0 ? void 0 : _f.map(function (bucket) { return ({
        name: bucket.tier_name,
        tier_value: bucket.tier_value,
        players: bucket.players,
        percentage: Math.round(bucket.percentage * 10) / 10,
    }); })) !== null && _g !== void 0 ? _g : [];
    if (tier_distribution && tier_distribution.no_tier > 0) {
        var denom = (tier_distribution.total_players || 0);
        tierDistributionData.push({
            name: "No Tier",
            tier_value: -1,
            players: tier_distribution.no_tier,
            percentage: denom > 0 ? Math.round((tier_distribution.no_tier / denom) * 1000) / 10 : 0,
        });
    }
    var retentionCurveData = (data === null || data === void 0 ? void 0 : data.retention)
        ? [
            {
                day: "D1",
                rate: Math.round(((_h = data.retention.day_1_retention) !== null && _h !== void 0 ? _h : 0) * 10) / 10,
                prev_rate: data.retention_comparison ? Math.round(((_j = data.retention_comparison.day_1_retention) !== null && _j !== void 0 ? _j : 0) * 10) / 10 : null,
            },
            {
                day: "D7",
                rate: Math.round(((_k = data.retention.day_7_retention) !== null && _k !== void 0 ? _k : 0) * 10) / 10,
                prev_rate: data.retention_comparison ? Math.round(((_l = data.retention_comparison.day_7_retention) !== null && _l !== void 0 ? _l : 0) * 10) / 10 : null,
            },
            {
                day: "D30",
                rate: Math.round(((_m = data.retention.day_30_retention) !== null && _m !== void 0 ? _m : 0) * 10) / 10,
                prev_rate: data.retention_comparison ? Math.round(((_o = data.retention_comparison.day_30_retention) !== null && _o !== void 0 ? _o : 0) * 10) / 10 : null,
            },
        ]
        : [];
    var hasPrevRetention = !!(data === null || data === void 0 ? void 0 : data.retention_comparison);
    var retentionEmpty = retentionCurveData.length === 0 || retentionCurveData.every(function (point) { return point.rate === 0; });
    var widgets = __spreadArray([
        {
            i: "line_chart",
            x: 0,
            y: 0,
            w: 10,
            h: 4,
            title: "Daily & Monthly Active Users",
            tooltip: "Per-day distinct active users. DAU = users active that day. MAU = users active in the trailing 30 days ending that day.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Daily & Monthly Active Users", data: mergedTimeSeries, dataKeys: __spreadArray([
                    { key: "dau", name: "Daily Active Users", color: chartColors_1.chartColors.success.base },
                    { key: "mau", name: "Monthly Active Users", color: chartColors_1.chartColors.secondary.base }
                ], (hasPrev
                    ? [
                        { key: "prev_dau", name: "DAU (prev period)", color: chartColors_1.chartColors.success.faded, dashed: true },
                        { key: "prev_mau", name: "MAU (prev period)", color: chartColors_1.chartColors.secondary.faded, dashed: true },
                    ]
                    : []), true), xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "dau_mau",
            x: 10,
            y: 0,
            w: 2,
            h: 2,
            hideTitle: true,
            noShell: true,
            content: ((0, jsx_runtime_1.jsx)(kpiCard_1.KPICard, { title: "Stickiness", subtitle: "DAU/MAU ratio", value: (0, formatChartData_1.formatPercentage)(data === null || data === void 0 ? void 0 : data.dau_mau_ratio), trend: (0, compareTimePeriods_1.formatComparison)(data === null || data === void 0 ? void 0 : data.dau_mau_ratio_comparison), tooltip: "Period-aggregate DAU divided by period-aggregate MAU. Higher = users return more often within the month." })),
        },
        {
            i: "total_members",
            x: 10,
            y: 2,
            w: 2,
            h: 2,
            hideTitle: true,
            noShell: true,
            content: ((0, jsx_runtime_1.jsx)(kpiCard_1.KPICard, { title: "Total Members", value: ((_p = data === null || data === void 0 ? void 0 : data.total_players) !== null && _p !== void 0 ? _p : 0).toLocaleString(), subtitle: data ? "".concat(((_q = data.active_users) !== null && _q !== void 0 ? _q : 0).toLocaleString(), " active \u00B7 ").concat(((_r = data.dormant_users) !== null && _r !== void 0 ? _r : 0).toLocaleString(), " dormant") : undefined, trend: (0, compareTimePeriods_1.formatComparison)(data === null || data === void 0 ? void 0 : data.total_players_comparison), tooltip: "All-time count of registered players. Trend compares membership size at the end of this period vs the end of the previous period." })),
        },
        {
            i: "retention_curve",
            x: 5,
            y: 4,
            w: 3,
            h: 4,
            title: "Retention Curve",
            tooltip: "Of new players registered in the period, the share who returned at least once 1 / 7 / 30 days later. Cohort excludes players too young to have reached each milestone.",
            empty: retentionEmpty,
            emptyText: "No mature cohort yet. Needs at least 30 days of player history",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Retention Curve", data: retentionCurveData, dataKeys: __spreadArray([
                    { key: "rate", name: "Retention (%)", color: chartColors_1.chartColors.success.base }
                ], (hasPrevRetention
                    ? [{ key: "prev_rate", name: "Retention (prev)", color: chartColors_1.chartColors.success.faded, dashed: true }]
                    : []), true), xAxisKey: "day", yDomain: [0, 100], noCard: true, loading: loading })),
        },
        {
            i: "dau_breakdown",
            x: 0,
            y: 4,
            w: 5,
            h: 4,
            title: "DAU Breakdown: New vs Returning",
            tooltip: "Per-day DAU split into first-time active users (new) and returning. A user counts as 'new' on the day their first activity matches their registration date.",
            content: ((0, jsx_runtime_1.jsx)(stackedAreaChartCard_1.StackedAreaChartCard, { title: "DAU Breakdown: New vs Returning", data: dauBreakdownData, areas: [
                    { key: "new", name: "New", color: chartColors_1.chartColors.success.base },
                    { key: "returning", name: "Returning", color: chartColors_1.chartColors.secondary.base },
                ], xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "activity_heatmap",
            x: 8,
            y: 4,
            w: 4,
            h: 4,
            title: "Activity Heatmap (Weekday × Hour)",
            tooltip: "Activity event counts bucketed by day-of-week and hour-of-day. Darker = more activity. Useful for timing challenges and notifications.",
            content: ((0, jsx_runtime_1.jsx)(activityHeatmapCard_1.ActivityHeatmapCard, { title: "Activity Heatmap (Weekday \u00D7 Hour)", cells: (_s = activity_heatmap === null || activity_heatmap === void 0 ? void 0 : activity_heatmap.cells) !== null && _s !== void 0 ? _s : [], loading: activity_heatmap_loading, noCard: true })),
        }
    ], (TIER_DISTRIBUTION_ENABLED
        ? [
            {
                i: "tier_distribution",
                x: 8,
                y: 8,
                w: 4,
                h: 4,
                title: "Tier Distribution",
                tooltip: "Current population of players per tier, derived from the latest TIER_PROGRESSION event per player and reward track. 'No Tier' = players who have never earned a tier.",
                content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Tier Distribution", data: tierDistributionData, barKeys: [{ key: "players", name: "Players", color: chartColors_1.chartColors.secondary.base }], xAxisKey: "name", layout: "vertical", noCard: true, loading: tier_distribution_loading })),
            },
        ]
        : []), true);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-bold text-foreground", children: "User Engagement" }), (0, jsx_runtime_1.jsx)(dashboardGrid_1.DashboardGrid, { widgets: widgets })] }));
});
exports.UserEngagementSection = UserEngagementSection;
UserEngagementSection.displayName = "UserEngagementSection";
